import apiHttpClient from "./ApiHttpClient";

export default class UserAgreementRepository {
  /**
   * storeAgreement
   * @param {string} pagePath
   * @returns {Promise}
   */
  async storeAgreement() {
    try {
      const res = await apiHttpClient.post(
        `user_agreement/store`,
      );
      location.reload();
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}
